module.exports = __webpack_public_path__ + "static/media/login-bg-img.8caf1b4f.jpeg";